<template>
  <b-modal
    id="authorization-modal"
    :title="title"
    centered
    body-class="p-0"
    hide-footer
    @hide="handleHideModal">
    <b-tabs
      nav-class="mb-0 d-none d-md-flex lh-1 fs-6"
      nav-wrapper-class="bg-aba-secondary"
      no-nav-style>
      <b-tab active title-link-class="pt-3 pb-2 text-white" :title="translations[4741]">
        <auth-form-applicant />
      </b-tab>
      <b-tab title-link-class="pt-3 pb-2 text-white" :title="translations[1388]">
        <auth-form-company />
      </b-tab>
      <b-tab title-link-class="pt-3 pb-2 text-white" :title="translations[13727]">
        <auth-form-consultant />
      </b-tab>
    </b-tabs>
  </b-modal>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import AuthFormApplicant from '@/components/Authorization/AuthFormApplicant.vue';
import AuthFormCompany from '@/components/Authorization/AuthFormCompany.vue';
import AuthFormConsultant from '@/components/Authorization/AuthFormConsultant.vue';
import { AppModule } from '@/store/modules/app';

@Component({
  components: {
    AuthFormApplicant,
    AuthFormCompany,
    AuthFormConsultant,
  },
})
export default class AuthorizationModal extends Vue {
  get translations() {
    return AppModule.translation;
  }

  get title() {
    return AppModule.isRegistrationTab ? this.translations[13781] : this.translations[13726];
  }

  handleHideModal() {
    AppModule.SET_REGISTRATION_TAB(false);
  }
}
</script>
